import React, { Component } from "react";

import Label from "../../../components/atoms/Label";
import TextBox from "../../../components/atoms/TextBox";
import Button from "../../../components/atoms/Button";

class FormLogin extends Component {
	constructor(props) {
		super(props);
		this.state = {
			email: "",
			password: "",
		};
	}

	changeValueState = ({ name, value }) => {
		this.setState({
			[name]: value,
		});
	};

	render() {
		const { email, password } = this.state;
		const { status, onSubmit } = this.props;

		return (
			<form
				onSubmit={(e) => {
					e.preventDefault();
					onSubmit({ email, password });
				}}
				className="box-login d-flex flex-column align-items-center"
			>
				<Label type="title" className="label-kc-mb mb-1" value="Masuk Sebagai Peminjam" />
				{/* <p>{test}</p> */}
				{/* <p>{JSON.stringify(process.env)}</p> */}
				<div className="d-flex justify-content-center align-items-center mb-5">
					<Label type="paragraph" value="Belum memiliki akun ?" />
					<Label
						type="paragraph"
						className="blue ml-1 link"
						onClick={() => {
							this.props.history.push("/register");
						}}
						value="Daftar di Sini"
					/>
				</div>

				{status.error && (
					<div>
						{" "}
						<label className="label-kc red text-left mt-0 mb-3">
							{" "}
							<strong>Error!</strong> {status.error}{" "}
						</label>{" "}
					</div>
				)}

				<div className="form-group">
					<TextBox name="email" placeholder="Surel" value={email} onChange={(e) => this.changeValueState(e.target)} type="text" />
				</div>

				<div className="form-group">
					<TextBox name="password" placeholder="Password" value={password} onChange={(e) => this.changeValueState(e.target)} type="password" />
				</div>

				<Button type="submit" title="MASUK" loading={status.loading} className="mt-4" color="yellow" width="block" />

				<div className="d-flex justify-content-center align-items-center mt-3">
					<Label type="paragraph" value="Anda lupa kata sandi ?" />
					<Label
						type="paragraph"
						className="blue ml-1 link"
						onClick={() => {
							this.props.history.push("forgot-password");
						}}
						value="Lupa Kata Sandi"
					/>
				</div>

				<div className="d-flex justify-content-center align-items-center mt-1">
					<Label type="paragraph" value="Belum menerima surel verifikasi ?" />
					<Label
						type="paragraph"
						className="blue ml-1 link"
						onClick={() => {
							this.props.history.push("resend-verification");
						}}
						value="Kirim Ulang Verifikasi"
					/>
				</div>

				<div className="ojk-section-login d-flex justify-content-between align-items-center">
					<small>
						PT KLIKCAIR MAGGA JAYA telah berizin dan
						<br />
						diawasi oleh Otoritas Jasa Keuangan (OJK)
					</small>

					<div className="logo-ojk-login d-flex justify-content-end align-items-center flex-1">
						<img src="https://kc-storage.oss-ap-southeast-5.aliyuncs.com/storage/assets/images/partner_logo/OJK.png" alt="logo-ojk" />
						<img src="https://kc-storage.oss-ap-southeast-5.aliyuncs.com/storage/assets/images/partner_logo/Stamp-Legal-100-Blok.png" alt="logo-ojk" />
					</div>
				</div>
			</form>
		);
	}
}

export default FormLogin;
